import { useEffect } from "react";
import { useDashT } from "./dashboardStrings";

export const usePageTitle = (title) => {
  const dt = useDashT();
  useEffect(() => {
    document.title = title ? `${dt(title)} | Talentsio` : "Talentsio - Book talent for your event";
  }, [title, dt]);
};
